<template>
  <div>
    <TableResults :sortColumn="sort.column" :direction="sort.direction" :records="records" :budgetType="budgetType" v-on:modal="(record) => $emit('modal', record)" v-on:order="order"></TableResults>
    <nav :aria-label="$t('page-navigation')" v-if="total_pages > 0">
      <ul class="pagination mt-4">
        <li v-if="current_page === 1" class="page-item disabled"><a tabindex="-1" aria-disabled="true" class="page-link"><i aria-hidden="true" class="far fa-angle-left"></i><span class="sr-only">&nbsp;&nbsp;{{ $t('previous') }}</span></a></li>
        <li v-else class="page-item"><a @click="set_page(current_page - 1)" class="page-link"><i aria-hidden="true" class="far fa-angle-left"></i><span class="sr-only">&nbsp;&nbsp;{{ $t('previous') }}</span></a></li>

        <li v-for="(page_num,index) in pages_array" :key="index" class="page-item" :class="{'active': page_num && page_num === current_page}">
            <a v-if="page_num" class="page-link" @click="set_page(page_num)">{{ page_num }}</a>
            <span v-else class="page-indicator">...</span>
        </li>

        <li v-if="current_page === total_pages" class="page-item disabled"><a tabindex="-1" aria-disabled="true" class="page-link"><span class="sr-only">{{ $t('next') }}&nbsp;&nbsp;</span><i aria-hidden="true" class="far fa-angle-right"></i></a></li>
        <li v-else class="page-item"><a @click="set_page(current_page + 1)" class="page-link"><span class="sr-only">{{ $t('next') }}&nbsp;&nbsp;</span><i aria-hidden="true" class="far fa-angle-right"></i></a></li>
      </ul>
    </nav>
  </div>
</template>
<script>
import OpenData from '../libraries/OpenData';
import TableResults from './TableResults.vue';

export default {
    props: ["wheres","budgetType"],
    components: { TableResults },
    data() {
        return {
            records: [],
            limit: 10,
            offset: 0,
            sort: {
                column: "sum_capital_cost",
                direction: "DESC",
            },
            number_of_records: null,
            loading: false,
        };
    },
    created() {
        this.fetch_number_records();
        this.fetch();
    },
    watch: {
        count_pages_parameters() {
            this.fetch_number_records();
        },
        parameters() {
            this.fetch();
        },
        wheres() {
            this.set_page(1);
        },
        order_parameters() {
            this.set_page(1);
        }
    },
    methods: {
        order(column,direction) {
            this.sort.column = column;
            this.sort.direction = direction;
        },
        clearFilter() {
            this.filter_for = null;
        },
        set_page(page) {
            this.offset = ((page - 1) * this.limit);
        },
        sort_click(sort) {
            this.sort = sort;
            this.fetch();
        },
        async fetch() {
            const params = this.parameters;
            this.loading = true;
            const data = await OpenData.getResults(this.$OPEN_DATA_API, params);
            this.records = data;
            this.loading = false;
        },
        async fetch_number_records() {
            const params = this.count_pages_parameters;
            const data = await OpenData.getResults(this.$OPEN_DATA_API, params);
            this.number_of_records = data[0].count;
        },
    },
    computed: {
        order_parameters() {
            return [{ key: this.sort.column, direction: this.sort.direction }];
        },
        group_parameters() {
            return {
                select: ['investment_name','department','service_area','investment_type','spap_theme','lifecycle_activity_driver','class_estimate','ward', 'location', 'project_details'],
                function_column: ['capital_cost','funded','unfunded','previously_approved_project_funding',
                            'preliminary_capital_cost_6_year','preliminary_capital_cost_10_year',
                            'preliminary_funded_6_year','preliminary_funded_10_year',
                            'preliminary_unfunded_6_year','preliminary_unfunded_10_year'],
                function: ['sum','sum','sum','sum',
                      'sum','sum','sum','sum','sum','sum'],
                group: ['investment_name','department','service_area','investment_type','spap_theme','lifecycle_activity_driver','class_estimate','ward', 'location', 'project_details']
            }
        },
        parameters() {
            let where_parameters = this.wheres;
            let order_parameters = this.order_parameters;
            let limit_parameters = { limit: this.limit, offset: this.offset };
            let group_parameters = this.group_parameters;
            return { where_parameters, order_parameters, limit_parameters, group_parameters };
        },
        count_pages_parameters() {
            const where_parameters = this.wheres;
            const select_parameters = ["count(DISTINCT investment_name) as count"];
            return { where_parameters, select_parameters };
        },
        current_page() {
            return Math.floor(this.offset / this.limit) + 1;
        },
        total_pages() {
            return Math.ceil(this.number_of_records / this.limit);
        },
        pages_array() {
            var pages = [];
            let i = 0;
            if (this.total_pages < 6) {
                for (i = 0; i < this.total_pages; i++) {
                    pages.push(i + 1);
                }
            }
            else {
                var window_start = this.current_page - 1;
                var window_end = this.current_page + 1;
                if (this.current_page < 3) {
                    window_start = 2;
                    window_end = 3;
                }
                else if (this.current_page > this.total_pages - 3) {
                    window_start = this.total_pages - 3;
                    window_end = this.total_pages - 1;
                }
                let middle = [];
                for (i = window_start; i <= window_end; i++) {
                    middle.push(i);
                }
                //[null is used to bring up the ... in the pagination]
                const start = (middle[0] === 2) ? [1] : [1, null];
                const end = (middle[middle.length - 1] === this.total_pages - 1) ? [this.total_pages] : [null, this.total_pages];
                pages = pages.concat(start, middle, end);
            }
            return pages;
        }
    },
}

</script>
